export default {
  TT107: 0,
  AO: 1,
};
